import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import {WKInfiniteScroll, WKSkeletonScreen, WKNoData} from '../components/wk'
import {WKError} from '../components'
import '../css/page/LiveroomFollowersPage.css'


class LiveroomFollowersPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isPending: false,
            initialized: false,
            page: 0,
            liveroomName: '--'
        }
    }

    componentDidMount() {
        this.fetchFollowers()
    }

    fetchFollowers() {
        const {page} = this.state
        document.title = '粉丝列表'
        this.setState({isPending: true, page: page + 1}, () => {
            axios.get(`/api/liveroom/${this.props.params.liveroom_id}/followers`, {
                params: {
                    limit: 20,
                    page: this.state.page
                }
            }).then(res => {
                if (res.data.code === 0) {
                    let {has_more, records, liveroom_name} = res.data.data
                    this.setState({
                        liveroomName: liveroom_name || '--'
                    })
                    if (!this.state.records) {
                        this.setState({has_more, records, initialized: true, isPending: false})
                    } else {
                        records = this.state.records.concat(records)
                        this.setState({has_more, records, initialized: true, isPending: false})
                    }
                }
            }).catch(error => {
                if (error.response && error.response.status === 403) {
                    this.props.dispatch({
                        type: 'ERROR_SHOW',
                        payload: {
                            tips: '你不是直播间管理员，点击返回',
                            href: `/liveroom/${this.props.params.liveroom_id}/?st=liveroom_followers_403`,
                            btn: '返回'
                        }
                    });
                }
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: '服务器出现拥挤了，请联系管理员',
                        href: `/liveroom/${this.props.params.liveroom_id}/?st=liveroom_followers_403`,
                        btn: '返回'
                    }
                });
            })
        })
    }

    render() {
        const {initialized, records, liveroomName} = this.state
        if (this.props.error.showError) {
            return (
                <div className="wk-page">
                    <WKError/>
                </div>
            )
        }

        if (!initialized) {
            return (
                <div className="wk-page">
                    <WKSkeletonScreen num={5}/>
                </div>
            )
        }

        return (
            <div className="liveroom-followers-page wk-page">
                <p className="follow-header">
                    <span className="follow-header-account wk-text-flow">{liveroomName}</span>的粉丝
                </p>
                {records.length > 0 ?
                    <div className="follow-body">
                        {records.map(item =>
                            <div className="follow-item wk-border-line-bottom" key={item.id}>
                                <div className="follow-item-image">
                                    <img className="follow-item-img" src={item.small_avatar_url}/>
                                </div>
                                <div className="follow-item-content">
                                    <p className="follow-item-name">{item.nickname}</p>
                                    <p className="follow-item-descri">{item.introduction}</p>
                                </div>
                            </div>
                        )}
                        <WKInfiniteScroll
                            onTouchBottom={() => this.fetchFollowers()}
                            isStop={this.state.isPending}
                            isKill={!this.state.has_more}
                            isShowLoading={true}
                        />
                    </div>
                    :
                    <WKNoData text="暂无关注者"/>
                }
            </div>
        )
    }
}

export default connect((state) => ({
    account: state.account,
    error: state.error
}))(LiveroomFollowersPage)


// WEBPACK FOOTER //
// ./src/pages/LiveroomFollowersPage.js